import { fetchCountryCode } from "lib/utils/getCountryCode";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";

export const PremiumCard = () => {
    const [countryCode, setCountryCode] = useState("IN");
    useEffect(() => {
        fetchCountryCode(setCountryCode);
      }, []);
      const price = countryCode === "IN" ? "₹69" : "$9";
    return (
        <div className="h-full w-full rounded-lg p-3 sm:p-4 lg:p-6 text-center bg-gradient-to-br from-[#151515] via-[#272626] to-[#2D2D2D] relative overflow-hidden flex flex-col justify-between">
            {/* Circular gradient in the center - responsive sizing */}
            <div className="absolute left-1/4 top-1/4 flex items-center justify-center pointer-events-none">
                <div className="w-[120px] h-[120px] sm:w-[180px] sm:h-[180px] md:w-[220px] md:h-[220px] lg:w-[250px] lg:h-[250px] z-[-10] rounded-full bg-gradient-to-r from-[#292828] to-[#000000] blur-md"></div>
            </div>
            
            {/* Top left arrow - responsive sizing and positioning */}
            <div className="absolute top-2 sm:top-5 md:top-8 lg:top-10 left-0 w-20 h-16 sm:w-40 sm:h-32 md:w-50 md:h-40 lg:w-60 lg:h-48">
                <Image 
                    src="/assets/purpleArrow.svg"
                    alt="Premium arrow"
                    width={150}
                    height={100}
                    className="transform scale-50 sm:scale-75 md:scale-90 lg:scale-100"
                />
            </div>
            
            <div className="relative z-10 flex flex-col justify-center">
                <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-white text-start">Upgrade to Premium</h2>
                <p className="text-sm sm:text-base md:text-xl text-start font-semibold text-[#9f9f9f]">to upgrade your <span className="text-blue-500">resume</span> game</p>
                <p className="text-[#f8e297] font-semibold mt-2 sm:mt-3 md:mt-5 text-lg sm:text-xl md:text-3xl">{price} <span className="text-white">only</span></p>
            </div>
            
            <div className="rounded-xl border border-white bg-black shadow-md px-3 py-2 sm:px-5 sm:py-3 md:px-8 md:py-4 my-3 md:mb-6 flex flex-col gap-1 sm:gap-2 z-10">
                <p className="text-white text-start font-semibold text-xs sm:text-sm md:text-base">• All sections ATS score</p>
                <p className="text-white text-start font-semibold text-xs sm:text-sm md:text-base">• Score improvement</p>
                <p className="text-white text-start font-semibold text-xs sm:text-sm md:text-base">• Get best suggestion</p>
            </div>
            
            <Link href="/premium-subscription" className="bg-gradient-to-br from-[#1F47E2] to-[#8CA3FF] text-white px-10 sm:px-16 md:px-20 py-1 sm:py-1.5 md:py-2 z-10 rounded-3xl hover:bg-blue-700 transition text-sm sm:text-base">
                Continue
            </Link>
            
            {/* Bottom right arrow - responsive positioning */}
            <div className="absolute bottom-5 sm:bottom-8 md:bottom-12 lg:bottom-16 right-0 w-[75px] h-[54px] sm:w-[100px] sm:h-[72px] md:w-[125px] md:h-[89px] lg:w-[150px] lg:h-[107px]">
                <Image 
                    src="/assets/purpleArrowRight.svg"
                    alt="Premium arrow"
                    width={150}
                    height={150}
                    className="transform scale-50 sm:scale-65 md:scale-80 lg:scale-100"
                />
            </div>
        </div>
    )
}